import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { useActionPermission } from "@/modules/auth/presentation/model/useActionPermission";
import type { ModifierListRow } from "@/modules/catalog/domain/types";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";


import { useNavigate } from "@tanstack/react-router";
import { PlusIcon } from "lucide-react";
import { useDeleteModifier, useModifiersQuery } from "../api/queries";
import { ModifiersTable } from "../ui/ModifiersTable";

export function ModifiersPage() {
  const nav = useNavigate({ from: "/app/catalog/modifiers" });
  const list = useModifiersQuery();
  const canManage = useActionPermission(["catalog:create"]);
  const deleteModifier = useDeleteModifier();

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            {
              label: "ຊຸດຕົວເລືອກ",
              to: "/app/catalog/modifiers",
            },
          ]}
        />
      </Header>
      <Main>
        <div className="mb-2 flex flex-col gap-4">
          <div className="flex flex-wrap items-center justify-between gap-2">
            <div className="flex flex-col">
              <h2 className="font-bold text-2xl tracking-tight">ຊຸດຕົວເລືອກ</h2>
              <p className="text-muted-foreground">
                ຈັດການຊຸດຕົວເລືອກເພີ່ມເຕີມ (modifier sets) ສຳລັບສິນຄ້າ.
              </p>
            </div>
            {canManage && (
              <Button
                onClick={() => nav({ to: "/app/catalog/modifiers/create" })}
              >
                <PlusIcon className="size-4" />
                ສ້າງຊຸດຕົວເລືອກ
              </Button>
            )}
          </div>
        </div>

        <div className="flex flex-col rounded-xl border bg-card">
          <ModifiersTable
            data={list.data ?? []}
            isLoading={list.isLoading}
            onEdit={(row: ModifierListRow) =>
              nav({
                to: "/app/catalog/modifiers/$id/edit",
                params: { id: row.id },
              })
            }
            onDelete={async (id) =>
              toast.promise(deleteModifier.run(id), {
                loading: "ກຳລັງລຶບ...",
                success: "ລຶບຊຸດຕົວເລືອກສຳເລັດ",
                error: "ລຶບຊຸດຕົວເລືອກລົ້ມເຫຼວ",
              })
            }
          />
        </div>
      </Main>
    </>
  );
}
